import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useState } from 'preact/hooks';
import { CampaignInfoSection } from '../CampaignInfoSection';
import { CampaignModal } from '../CampaignModal';
import { useUserProfile } from '@/hooks/useUserProfile';
export function CampaignDetailsTab({ campaign, clientCompanyId, selectedWorkspaceId, onCampaignUpdated }) {
    const { getWorkspaceCapabilities } = useUserProfile();
    const { canEdit } = getWorkspaceCapabilities(clientCompanyId, selectedWorkspaceId);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const handleCampaignSaved = (updatedCampaign) => {
        onCampaignUpdated(updatedCampaign);
        setIsEditModalOpen(false);
    };
    return (_jsxs("div", { children: [_jsx(CampaignInfoSection, { campaign: campaign, onEditCampaign: canEdit ? () => setIsEditModalOpen(true) : undefined }), isEditModalOpen && (_jsx(CampaignModal, { isOpen: isEditModalOpen, onClose: () => setIsEditModalOpen(false), selectedWorkspaceId: selectedWorkspaceId, onCampaignSaved: handleCampaignSaved, editCampaign: campaign, clientCompanyId: clientCompanyId }))] }));
}
